import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Plan } from "./components/Plan";
import { Complete } from "./components/Complete";

export const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/pages/plan" element={<Plan />} />
        <Route path="/pages/plan/complete" element={<Complete />} />
      </Routes>
    </Router>
  );
};